import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
  image: string;
}
const testimonials: TestimonialProps[] = [{
  name: 'Marcela S.',
  location: 'CDMX',
  text: 'Antes era imposible subir al elevador. Ahora entra tranquilo y se sienta a esperar. Un cambio total.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=faces'
}, {
  name: 'Ricardo G.',
  location: 'Santiago',
  text: 'Los paseos por los parques ya no son una pesadilla de tirones. Ustedes me devolvieron la paz.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces'
}, {
  name: 'Elena M.',
  location: 'Monterrey',
  text: 'Pensé que mi perro era agresivo, pero solo tenía miedo. Este protocolo nos salvó la vida.',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=faces'
}];
export function TestimonialStrip() {
  return <section className="py-8 bg-white border-y border-gray-200" data-id="element-137">
      <div className="max-w-6xl mx-auto px-4" data-id="element-138">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-139">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-[20px] shadow-md border border-gray-100 flex flex-col" data-id="element-140">
              <div className="flex items-center gap-3 mb-4" data-id="element-141">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-142" />
                <div className="flex-1" data-id="element-143">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-144">{t.name}</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-145">
                    {t.location}
                  </p>
                </div>
              </div>
              <div className="flex mb-3" data-id="element-146">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-147" />)}
              </div>
              <p className="text-gray-700 italic text-sm flex-grow" data-id="element-148">
                "{t.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}